import {
    SxProps,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { WorkingTimeModelDayOfWeek } from '@/generated/Enumerations/WorkingTimeModelDayOfWeek_pb'

export const WorkingTimeModelWeekdayTable: React.FC<{
    days: {
        dayOfWeek: WorkingTimeModelDayOfWeek
        startAt: React.ReactNode
        duration: React.ReactNode
    }[]
    sx?: SxProps
}> = ({ days, sx }) => {
    const { t } = useTranslation()

    const workingTimeModelDaysOfWeekToLabel: Record<
        WorkingTimeModelDayOfWeek,
        string
    > = {
        [WorkingTimeModelDayOfWeek.MONDAY]: t('dateTime.monday'),
        [WorkingTimeModelDayOfWeek.TUESDAY]: t('dateTime.tuesday'),
        [WorkingTimeModelDayOfWeek.WEDNESDAY]: t('dateTime.wednesday'),
        [WorkingTimeModelDayOfWeek.THURSDAY]: t('dateTime.thursday'),
        [WorkingTimeModelDayOfWeek.FRIDAY]: t('dateTime.friday'),
        [WorkingTimeModelDayOfWeek.SATURDAY]: t('dateTime.saturday'),
        [WorkingTimeModelDayOfWeek.SUNDAY]: t('dateTime.sunday'),
    }

    return (
        <TableContainer sx={sx}>
            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '20%' }}>
                            {t('dateTime.dayOfWeek')}
                        </TableCell>
                        <TableCell style={{ width: '40%' }}>
                            {t('dateTime.start')}
                        </TableCell>
                        <TableCell style={{ width: '40%' }}>
                            {t('dateTime.duration')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {days.length === 0 ?
                        <TableRow>
                            <TableCell
                                colSpan={3}
                                style={{ textAlign: 'center' }}
                            >
                                {t('dateTime.noDays')}
                            </TableCell>
                        </TableRow>
                    :   days.map(({ dayOfWeek, startAt, duration }, i) => (
                            <TableRow key={i}>
                                <TableCell>
                                    {
                                        workingTimeModelDaysOfWeekToLabel[
                                            dayOfWeek
                                        ]
                                    }
                                </TableCell>
                                <TableCell>{startAt}</TableCell>
                                <TableCell>{duration}</TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}
